import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  backupLogs: [],
  loading: false,
  error: null,
  successMessage: null,
  // Pagination
  page: 1,
  pageSize: 10,
  total: 0,
  // Sorting
  sortColumn: 'createdOn',
  sortDirection: 'desc',
};

const backupLogsSlice = createSlice({
  name: 'backupLogs',
  initialState,
  reducers: {
    // Fetch backup logs
    fetchBackupLogs: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchBackupLogsSuccess: (state, action) => {
      state.loading = false;
      state.backupLogs = action.payload.data;
      state.total = action.payload.meta.total;
      state.page = action.payload.meta.page;
      state.pageSize = action.payload.meta.size;
      state.error = null;
    },
    fetchBackupLogsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Delete backup log
    deleteBackupLog: (state) => {
      state.loading = true;
      state.error = null;
    },
    deleteBackupLogSuccess: (state, action) => {
      state.loading = false;
      state.backupLogs = state.backupLogs.filter((log) => log.id !== action.payload);
      state.total = Math.max(0, state.total - 1);
      state.error = null;
      state.successMessage = 'backupLogs.deleteSuccess';
    },
    deleteBackupLogFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Bulk delete backup logs
    bulkDeleteBackupLogs: (state) => {
      state.loading = true;
      state.error = null;
    },
    bulkDeleteBackupLogsSuccess: (state, action) => {
      state.loading = false;
      state.backupLogs = state.backupLogs.filter((log) => !action.payload.includes(log.id));
      state.total = Math.max(0, state.total - action.payload.length);
      state.error = null;
      state.successMessage = 'backupLogs.bulkDeleteSuccess';
    },
    bulkDeleteBackupLogsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Pagination
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
      state.page = 1; // Reset to first page
    },

    // Sorting
    setSortColumn: (state, action) => {
      state.sortColumn = action.payload;
    },
    setSortDirection: (state, action) => {
      state.sortDirection = action.payload;
    },

    // Clear error
    clearError: (state) => {
      state.error = null;
    },

    // Clear success message
    clearSuccessMessage: (state) => {
      state.successMessage = null;
    },
  },
});

export const {
  fetchBackupLogs,
  fetchBackupLogsSuccess,
  fetchBackupLogsFailure,
  deleteBackupLog,
  deleteBackupLogSuccess,
  deleteBackupLogFailure,
  bulkDeleteBackupLogs,
  bulkDeleteBackupLogsSuccess,
  bulkDeleteBackupLogsFailure,
  setPage,
  setPageSize,
  setSortColumn,
  setSortDirection,
  clearError,
  clearSuccessMessage,
} = backupLogsSlice.actions;

// Selectors
export const selectBackupLogs = (state) => state.backupLogs?.backupLogs || [];
export const selectBackupLogsLoading = (state) => state.backupLogs?.loading || false;
export const selectBackupLogsError = (state) => state.backupLogs?.error;
export const selectBackupLogsSuccessMessage = (state) => state.backupLogs?.successMessage;
export const selectBackupLogsTotal = (state) => state.backupLogs?.total || 0;
export const selectBackupLogsPage = (state) => state.backupLogs?.page || 1;
export const selectBackupLogsPageSize = (state) => state.backupLogs?.pageSize || 10;
export const selectBackupLogsSortColumn = (state) => state.backupLogs?.sortColumn || 'createdOn';
export const selectBackupLogsSortDirection = (state) => state.backupLogs?.sortDirection || 'desc';

export default backupLogsSlice.reducer;
